import React, { useEffect, useRef, useState, useCallback } from "react";
import "src/Assets/css/home/AsksModal.css";
import { Modal, Button, ModalFooter } from "react-bootstrap";
import Post from "./Post";
import { CircularProgress } from "@material-ui/core";
import style from "src/Assets/css/home/post.module.css";
import NoDataFound from "src/Assets/images/data-not-found.svg";
import styles from "src/Assets/css/home/Feed.module.css";
import API from "../../../network";
import RestrictionMsgModal from "src/Components/RestrictionMsgModal";

function AsksModal(props) {
  const {
    loading,
    childSaysLoading,
    answersToYourAsk,
    asksToBeAnswered,
    isPostOption,
    setSaysShow,
    askYourCommunity,
    fetchFeedData,
    postChildSayData,
    deleteMessage,
    filterPosts,
    childSaysData,
    fetchChildSaysData,
    fetchFollowData,
    fetchVoteUpStatus,
    deleteAnswersToAsksDialogPost,
    deletePossibleAnswerToAskPost,
    deleteAsksToBeAnsweredDialogPost,
    fetchContributors,
    onHashTagClick,
    askType,
    messageId,
    getListData,
    askActivityMessageRestrictionStatus = ""
  } = props;
  // const AskCanAns = useSelector(state => state.followReducer.sayData)
  // const saysCanAns = useSelector(state => state.followReducer.askData)
  // const isLoaded = useSelector(state => state.followReducer.isLoaded)

  const [modalText, setModalText] = useState("");
  const [lgShow, setLgShow] = useState(false);

  const [listData, setListData] = useState([]);
  const pageRef = useRef(0);

  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    if (isPostOption === "ASK") {
      setModalText("Possible answers to your ASK");
    } else if (isPostOption === "SAY") {
      setModalText(
        "A few related ASKs you could answer"
      );
    } else {
      setModalText("");
    }
  }, [isPostOption]);

  useEffect(() => {
    if (isPostOption === "ASK") {
      setListData(answersToYourAsk?.messageList || []);
    } else if (isPostOption === "SAY") {
      setListData(asksToBeAnswered?.messageList || []);
    }

    pageRef.current = 0;
    setHasMore(true);
  }, [
    answersToYourAsk?.messageList,
    asksToBeAnswered?.messageList,
    isPostOption,
  ]);

  const loadMoreData = useCallback(async () => {
    if (loadingMore || !hasMore) return;

    try {
      setLoadingMore(true);

      const nextPage = pageRef.current + 10;

      let newRecords = [];

      if (isPostOption === "ASK") {
        const formData = new FormData();

        formData.append("id", answersToYourAsk?.messageConnectionID);

        const response = await API.fetchAsksSearchResultData(
          nextPage,
          formData,
        );

        newRecords = response?.data?.messageList || [];
      } else if (isPostOption === "SAY") {
        const formData = new FormData();

        formData.append("messageID", asksToBeAnswered?.messageId);

        const response = await API.fetchAskListData(nextPage, formData);

        newRecords = response?.data?.messageList || [];
      }

      if (newRecords.length === 0) {
        setHasMore(false);
        return;
      }

      setListData((prev) => [...prev, ...newRecords]);

      pageRef.current = nextPage;

      if (newRecords.length < 10) {
        setHasMore(false);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingMore(false);
    }
  }, [
    loadingMore,
    hasMore,
    isPostOption,
    answersToYourAsk?.messageConnectionID,
    asksToBeAnswered?.messageId,
  ]);

  const handleScroll = useCallback(
    (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;

      if (isNearBottom) {
        loadMoreData();
      }
    },
    [loadMoreData],
  );

console.log(`messageId:`, messageId);
const onAskCommunitySelection = async (id) => {
  // Handle ASK restriction first
  if (isPostOption === "ASK") {
    if (
      answersToYourAsk?.messageConnectionStatus === "E" ||
      answersToYourAsk?.tenantSayStatus === "E" ||
      answersToYourAsk?.status === "E" ||
      askActivityMessageRestrictionStatus === "E"
    ) {
      setLgShow(true);
    }
  }

  try {
    // WAIT for API to complete
    const res = await askYourCommunity(id);

    // Only on success
    if (res?.data?.Status === "OK") {

      // Refresh feed (common logic)
      filterPosts && filterPosts("");

      // if this exists in that component
      getListData && getListData();
    }

  } catch (e) {
    console.error(e);
  } finally {
    // Close modal always
    setSaysShow(false);
  }
};

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
        className={
          askType && askType === "ActivityAskPost"
            ? `my-modal ${style.activityAskPost}`
            : "my-modal"
        }
        enforceFocus={false}
      >
        <Modal.Header closeButton style={{ paddingBottom: "0px" }}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="title"
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              padding: "10px",
              paddingBottom: "0px",
            }}
          >
            {(answersToYourAsk?.messageList?.length > 0 ||
              asksToBeAnswered?.messageList?.length > 0) &&
              modalText}
          </Modal.Title>
        </Modal.Header>

        {/* i have commented the modal body to chcek the UI design  */}
        <Modal.Body
          className="ModalPosts"
          onScroll={handleScroll}
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {loading ? (
            <CircularProgress
              size={30}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
              }}
            />
          ) : answersToYourAsk &&
            answersToYourAsk.messageList &&
            answersToYourAsk.messageList.length > 0 &&
            isPostOption === "ASK" ? (
            <Post
              deleteMessage={deleteMessage}
              fetchFeedData={fetchFeedData}
              postChildSayData={postChildSayData}
              loading={childSaysLoading}
              listdata={listData}
              data={answersToYourAsk}
              // isAskModal="isAskModal"
              isPostOption={isPostOption}
              childSaysData={childSaysData}
              fetchChildSaysData={fetchChildSaysData}
              fetchFollowData={fetchFollowData}
              fetchVoteUpStatus={fetchVoteUpStatus}
              deleteAnswersToAsksDialogPost={deleteAnswersToAsksDialogPost}
              deletePossibleAnswerToAskPost={deletePossibleAnswerToAskPost}
              fetchContributors={fetchContributors}
              onHashTagClick={onHashTagClick}
            />
          ) : asksToBeAnswered &&
            asksToBeAnswered.messageList &&
            asksToBeAnswered.messageList.length > 0 &&
            isPostOption === "SAY" ? (
            <div>
              {asksToBeAnswered.tenantSayStatus === "E" && (
                <p className={style.restrictionTestUnderSayPost}>
                  Your SAY will publish as soon as the Community Moderator
                  approves it.
                </p>
              )}
              <Post
                deleteMessage={deleteMessage}
                fetchFeedData={fetchFeedData}
                postChildSayData={postChildSayData}
                loading={childSaysLoading}
                listdata={listData}
                data={asksToBeAnswered}
                isAskModal="isAskModal"
                isPostOption={isPostOption}
                childSaysData={childSaysData}
                fetchChildSaysData={fetchChildSaysData}
                fetchFollowData={fetchFollowData}
                fetchVoteUpStatus={fetchVoteUpStatus}
                deleteAsksToBeAnsweredDialogPost={
                  deleteAsksToBeAnsweredDialogPost
                }
                fetchContributors={fetchContributors}
                onHashTagClick={onHashTagClick}
              />
            </div>
          ) : (
            <div className={style.notFoundImageContainer}>
              {/* <img src={NoDataFound} alt="notFoundImage" /> */}
              <p className={style.notFoundImageContainerParagraph1}>
                Sorry! No Results Found
              </p>
              <p className={style.notFoundImageContainerParagraph2}>
                We could not find any immediate answers or related content for
                your ASK. You can click the ASK Community button to post your
                ASK in the Community feed. You will be notified when members
                post answers to your ASK.
              </p>
            </div>
          )}
        </Modal.Body>
        {loadingMore && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "10px",
            }}
          >
            <CircularProgress size={20} />
          </div>
        )}
        <ModalFooter>
          <div className={style.modalFooter}>
            {!loading ? (
              (answersToYourAsk &&
                answersToYourAsk?.messageList &&
                Object.keys(answersToYourAsk.messageList).length > 0) ||
              (asksToBeAnswered &&
                asksToBeAnswered?.messageList &&
                Object.keys(asksToBeAnswered.messageList).length > 0) ? (
                <div style={{ marginBottom: "-3px" }}>
                  {isPostOption === "ASK" && <p>Not happy with results?</p>}
                </div>
              ) : (
                <div>{isPostOption === "ASK" && <p></p>}</div>
              )
            ) : null}

            {
              isPostOption === "ASK" ? (
                <button
                  className="PostCommunity askCommunity"
                  onClick={() =>
                    onAskCommunitySelection(
                      answersToYourAsk.messageConnectionID || messageId,
                    )
                  }
                >
                  ASK Community
                </button>
              ) : null
              // <button className="PostCommunity sayCommunity">SAY Community</button>
            }
          </div>
        </ModalFooter>
      </Modal>
      {lgShow && (
        <RestrictionMsgModal
          open={lgShow}
          onClose={() => setLgShow(false)}
          title="Thank you"
          message="Your ASK will publish as soon as the Community Moderator approves it."
        />
      )}
    </>
  );
}
export default AsksModal;
